import React ,{Component} from "react";
import Image from "react-bootstrap/Image";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";


class EstateGallery extends Component {
    render() {
        if (this.props.images.length === 0) {
            return null;
        }

        const settings = {
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '40px',
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        };

        return (
            <div className="img-preview md-mb50">
                <div className="gallery-top">
                    <div className="slider-carousel" style={{padding: 0}}>
                        <Slider {...settings}>
                            {this.props.images.map((image, key) => {
                                const image_src = image ?? process.env.REACT_APP_BASE_URL + "/images/default/project.jpg";
                                return (
                                    <article key={key} className="carousel-direction">
                                        <div className="property_item heading_space">
                                            <div className="image">
                                                <Image
                                                    src={image_src}
                                                    alt="latest property"
                                                    className="img-responsive"
                                                    style={{maxHeight: 500}}
                                                />
                                            </div>
                                        </div>
                                    </article>
                                );
                            })}
                        </Slider>
                    </div>
                </div>
            </div>
        );

        /*console.log('images: ', this.props.images);
        let image_url = (this.props.images && this.props.images[0] && !this.props.images[0].includes("default.jpg")) ?
            this.props.images[0]:
            process.env.REACT_APP_BASE_URL + "/images/default/estate.jpg";

        console.log('image_url: ', image_url);

        return (
            <div className="img-preview md-mb50">
                <div className="gallery-top">
                    <div className="swiper-container">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <div className="img">
                                    <Image src={image_url} alt=""/>
                                </div>
                            </div>
                            {/!*<div className="swiper-slide">
                                <div className="img">
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/default/estate.jpg"} alt=""/>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="img">
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/default/estate.jpg"} alt=""/>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="img">
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/default/estate.jpg"} alt=""/>
                                </div>
                            </div>*!/}
                        </div>
                    </div>
                </div>
                {/!*<div className="gallery-thumb mt-10">
                    <div className="swiper-container">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <div className="img">
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/default/estate.jpg"} alt=""/>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="img">
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/default/estate.jpg"} alt=""/>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="img">
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/default/estate.jpg"} alt=""/>
                                </div>
                            </div>
                            <div className="swiper-slide">
                                <div className="img">
                                    <Image src={process.env.REACT_APP_BASE_URL + "/images/default/estate.jpg"} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>*!/}
            </div>
        );*/
    }
}

export default EstateGallery;
